    import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import '../style/signup.css';
import signup from '../assets/signupimage.png';

const SignUpForm = () => {
  return (
     <div>
        <section className='signup'>
            <Container >
        <Row>
          <Col lg={7} className="form-section p-4">
            <h2>
              Sign Up to <em className="fw-semibold">create</em><br />account
            </h2>
            <h6>
              Already have an account? <a href="/basicinformation" className="text-decoration-underline">Log in</a>
            </h6>

            <form className="mt-4">
              <div className="mb-3">
                <label>Name</label>
                <input type="text" className="form-control" placeholder="Enter your profile name" />
              </div>

              <div className="mb-3">
                <label>What’s your email?</label>
                <input type="email" className="form-control" placeholder="Enter your email" />
              </div>

              <div className="mb-3 position-relative">
                <label>Create a password</label>
                <input type="password" className="form-control" placeholder="Enter your password" />
                <span className="password-eye">👁 Hide</span>
                <h5 className="form-note">Use 8 or more characters with a mix of letters, numbers & symbols</h5>
              </div>

              <div className="mb-3">
                <label>ZIP / Postal Code</label>
                <input type="text" className="form-control" placeholder="Enter your email" />
              </div>

              <div className="planeuse">
                <p className="howdoyouuse">How do you plan to use?</p>
                <div className="form-check">
                  <input className="form-check-input" type="radio" name="usage" id="buying" />
                  <label className="form-check-label" htmlFor="buying">Buying Items</label>
                </div>
                <div className="form-check">
                  <input className="form-check-input" type="radio" name="usage" id="selling" />
                  <label className="form-check-label" htmlFor="selling">Selling Items</label>
                </div>
                <div className="form-check">
                  <input className="form-check-input" type="radio" name="usage" id="both" />
                  <label className="form-check-label" htmlFor="both">Both buying and selling items</label>
                </div>
              </div>

              <div className="form-check mb-2">
                <input className="form-check-input" type="checkbox" id="emails" defaultChecked />
                <label className="form-check-label emailcheckform text-success small" htmlFor="emails">
                  Receive Helpful Emails From Farmish <br/>
                  <p>Feature updates, discounts and community tips.</p>
                </label>
              </div>

              <div className="form-check mb-2">
                <input className="form-check-input mt-1" type="checkbox" id="terms" />
                <label className="form-check-label small" htmlFor="terms">
                  I have read and agree to the 
                  <a href="#" className="small-link"> terms of service</a> and 
                  <a href="#" className="small-link"> privacy policy</a>.
                </label>
              </div>

              <p className="form-note">
                By creating an account, you agree to the 
                <a href="#" className="text-decoration-underline"> Terms of Use</a> and 
                <a href="#" className="text-decoration-underline"> Privacy Policy</a>.
              </p>

              <Button href="/basicinformation" type="submit" className="btn btn-submit w-100 mt-3">
                Create an account
              </Button>
            </form>
          </Col>

          {/* Image Section */}
          <Col lg={5} className="image-section">
            <img src={signup} alt="Farmers Market" className="img-fluid w-100" />
          </Col>

        </Row>
      </Container>
        </section>
     </div>
  );
};

export default SignUpForm;